import { clearUser } from "@store/auth/userSlice";
import { setAccountNumbersData } from "@store/modules/accountManagement/accountNumbersSlice";
import axios from "axios";

const handleUnauthorized = (dispatch, navigate) => {
	if (dispatch && navigate) {
		dispatch(clearUser());
		navigate("/login");
	} else {
		console.error("Dispatch or navigate function is missing.");
	}
};

export const fetchAccountNumbersData = async (
	token,
	dispatch,
	navigate,
	page = 1,
	perPage = 10,
	paginate = 0,
	searchTerms,
	store = true,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			page: page,
			per_page: perPage,
			paginate: paginate,
			isPool: searchTerms?.filter,
			country: searchTerms?.country,
			number: searchTerms?.number,
			isMobile: searchTerms?.isMobile,
			store: store,
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers`,
			config,
		);

		let data;
		if (!response.data || response.data.length === 0) {
			data = {
				data: [],
				totalItems: 0,
				page: paginate === 1 ? page : 1,
				perPage: paginate === 1 ? perPage : 10,
			};
		} else if (paginate === 1) {
			const totalItems = response.data?.total;
			data = {
				data: response.data.data,
				totalItems: totalItems,
				page: paginate === 1 ? page : 1,
				perPage: paginate === 1 ? perPage : 10,
			};
		} else {
			data = {
				data: response.data,
				totalItems: 0,
				page: 1,
				perPage: 10,
			};
		}

		store && dispatch(setAccountNumbersData(data));
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching AccountNumbers data:", error);
		}
	}
};

export const fetchScapData = async (token, dispatch, navigate, clientId) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/scap/configs-client/${clientId}`,
			config,
		);
		const data = response.data.scap_configs;
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching AccountNumbers data:", error);
		}
	}
};
export const fetchAccountNumbersCountriesData = async (token, dispatch, navigate, store = true) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		// params: {
		//   country: searchTerms?.country,
		//   is_mobile: searchTerms?.is_mobile === "MOBILE" ? 1 : 0,
		//   is_pool: searchTerms?.is_pool,
		// },
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers/countries`,
			config,
		);

		let data;
		if (!response.data || response.data.length === 0) {
			data = {
				data: [],
			};
		} else {
			data = response.data;
		}

		store && dispatch(setAccountNumbersData(data));
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching AccountNumbers data:", error);
		}
	}
};

export const fetchAccountNumbersSelectData = async (
	token,
	dispatch,
	navigate,
	searchTerms,
	store = true,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			is_mobile: searchTerms?.is_mobile === "MOBILE" ? 1 : 0,
			is_pool: searchTerms?.is_pool,
			subscription_ids: searchTerms?.subscription_plan,
			country: searchTerms?.countryName,
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers/select`,
			config,
		);

		let data;
		if (!response.data || response.data.length === 0) {
			data = {
				data: [],
			};
		} else {
			data = {
				data: response.data,
			};
		}

		store && dispatch(setAccountNumbersData(data));
		return data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching AccountNumbers data:", error);
		}
	}
};
export const createAccountNumber = async (formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers`,
			formData,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 422) {
			return { errors: error.response.data.errors };
		} else {
			console.error("Error creating AccountNumber:", error);
		}
		return null;
	}
};

export const updateAccountNumbers = async (id, formData, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	};
	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers/${id}`,
			formData,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response && error.response.status === 422) {
			return { errors: error.response.data.errors };
		} else {
			console.error("Error updating AccountNumber:", error);
		}
		return null;
	}
};

export const deleteAccountNumberById = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	try {
		const response = await axios.delete(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers/${id}`,
			config,
		);
		if (response.status === 200 || response.status === 202 || response.status === 204) {
			return {
				status: "success",
				message: "Account number deleted successfully.",
			};
		} else {
			return {
				status: "error",
				message: response.data?.message || "An unexpected error occurred.",
			};
		}
	} catch (error) {
		if (error.response) {
			switch (error.response.status) {
				case 401:
					handleUnauthorized(dispatch, navigate);
					break;
				case 404:
					return { status: "not_found", message: "Not found." };
				case 405:
					return {
						status: "method_not_allowed",
						message: "Method Not Allowed",
					};
				case 400:
					return {
						status: "error",
						message: error.response.data?.message || "An error occurred.",
					};
				default:
					return { status: "error", message: "An error occurred." };
			}
		} else {
			return { status: "error", message: "Network error" };
		}
	}
};

export const getAccountNumberById = async (id, token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers/${id}`,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};

export const getConfigurationByClientId = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
		params: {
			client: id,
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations`,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};

export const postConfigurationByClientId = async (selectedRow, token, formData) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};

	const params = {
		client_id: selectedRow,
		type: formData.type,
		status: formData.status ?? 0,

		account_number_id: formData.account_number_id,
		vessel_subscription_ids: formData.subscription,
		...(formData.isPool === 1 && {
			block_product: formData.is_block_related === "yes" ? 1 : 0,
		}),
		...(formData.type === "LAND" && { country: formData.countryName }),
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations`,
			params,
			config,
		);
		return { status: response.status, data: response.data }; // Return data on success
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};
export const putConfigurationByClientId = async (
	account_number_config,
	token,
	formData,
	config_scope,
	clientId,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};

	const params = {
		type: formData.type,

		// fixed_address: formData.fixed_address,
		account_number_id: formData.account_number_id,
		status: formData.status ?? 0,
		vessel_subscription_ids: formData.subscription,
		...(formData.isPool === 1 && {
			block_product: formData.is_block_related === "yes" ? 1 : 0,
		}),
		...(formData.type === "LAND" && { country: formData.countryName }),
		config_scope: config_scope,
		entity_id: clientId,
	};

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations/${account_number_config}`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};

export const getConfigurationByVesselId = async (id, token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
		params: {
			vessel: id,
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations`,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};

export const postConfigurationByVesselId = async (selectedrow, token, formData) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};
	const params = {
		vessel_id: selectedrow,
		type: formData.type,
		status: formData.status ?? 0,
		account_number_id: formData.account_number_id,
		vessel_subscription_ids: formData.subscription,
		...(formData.isPool === 1 && {
			block_product: formData.is_block_related === "yes" ? 1 : 0,
		}),
		...(formData.type === "LAND" && { country: formData.countryName }),
	};
	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};

export const putConfigurationByVesselId = async (
	account_number_config,
	token,
	formData,
	config_scope,
	vesselId,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};

	const params = {
		type: formData.type,

		// fixed_address: formData.fixed_address,
		account_number_id: formData.account_number_id,
		status: formData.status ?? 0,
		vessel_subscription_ids: formData.subscription,
		...(formData.isPool === 1 && {
			block_product: formData.is_block_related === "yes" ? 1 : 0,
		}),
		...(formData.type === "LAND" && { country: formData.countryName }),
		config_scope: config_scope,
		entity_id: vesselId,
	};

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations/${account_number_config}`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};

export const getConfigurationByBusinessUnitId = async (id, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
		params: {
			business_unit: id,
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations`,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};

export const postConfigurationByBusinessUnitId = async (selectedrow, token, formData) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};
	const params = {
		business_unit_id: selectedrow,
		type: formData.type,
		status: formData.status ?? 0,
		account_number_id: formData.account_number_id,
		vessel_subscription_ids: formData.subscription,
		...(formData.isPool === 1 && {
			block_product: formData.is_block_related === "yes" ? 1 : 0,
		}),
		...(formData.type === "LAND" && { country: formData.countryName }),
		is_prorata: formData.is_prorata,
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};

export const putConfigurationByBusinessUnitId = async (
	account_number_config,
	token,
	formData,
	config_scope,
	buId,
) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};

	const params = {
		type: formData.type,
		// fixed_address: formData.fixed_address,
		account_number_id: formData.account_number_id,
		status: formData.status ?? 0,
		vessel_subscription_ids: formData.subscription,
		...(formData.isPool === 1 && {
			block_product: formData.is_block_related === "yes" ? 1 : 0,
		}),
		...(formData.type === "LAND" && { country: formData.countryName }),
		is_prorata: formData.is_prorata,
		config_scope: config_scope,
		entity_id: buId,
	};

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations/${account_number_config}`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};

export const postPushConfigurationByBusinessUnitId = async (id, token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};
	const params = {
		business_unit_id: id,
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations/push`,
			params,
			config,
		);
		return { status: response.status, data: response.data }; // Return data on success
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};

export const postPushConfigurationByClientId = async (id, token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "*/*",
		},
	};

	const params = {
		client_id: id,
	};
	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations/push`,
			params,
			config,
		);
		return { status: response.status, data: response.data }; // Return data on success
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		// Catch-all for other types of errors (e.g., network issues)
		console.error("Error  configuration:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};
export const postSpecialConfig = async (clientId, specialConfig, token, dispatch, navigate) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			Accept: "*/*",
			"Content-Type": "multipart/form-data",
		},
	};

	const formData = new FormData();
	formData.append("client_id", clientId);
	formData.append("special_config", specialConfig); // usually 0 or 1

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/account-number-configurations/special-config`,
			formData,
			config,
		);
		return {
			status: response.status,
			data: response.data,
		};
	} catch (error) {
		if (error.response?.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else if (error.response?.status === 422) {
			return {
				status: 422,
				errors: error.response.data.errors,
			};
		}

		console.error("Error posting special config:", error);
		return {
			status: error.response?.status || 500,
			message: "Unexpected error occurred.",
		};
	}
};

export const fetchSubscriptionPlans = async (token, dispatch, navigate, params) => {
	const { account_number, is_mobile, is_pool, kit, block_product, vessel_starlink, country } =
		params;

	if (typeof is_mobile === "undefined") {
		throw new Error("is_mobile  are required parameters.");
	}

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		params: {
			is_mobile: String(is_mobile)?.toLowerCase() === "mobile" || Number(is_mobile) === 1 ? 1 : 0,
			is_pool: is_pool,
			kit: kit,
			account_number: account_number,
			block_product: block_product,
			vessel_starlink: vessel_starlink,
			country: country || null,
		},
	};

	try {
		const response = await axios.get(
			`${import.meta.env.VITE_API_BACKEND}api/account-numbers/subscription-plans`,
			config,
		);

		return response.data;
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching subscription plans:", error);
		}

		throw error; // Re-throw the error for additional handling.
	}
};

export const postManualActivation = async (token, dispatch, navigate, data) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			// // "Content-Type": "multipart/form-data",
			// "Content-Type": "application/json",
			// Accept: "*/*",
		},
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlink-activations/manual-activation`,
			data,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error.response);
			return { status: error.response.status, data: error.response.data };
			throw error;
		}
	}
};

export const postActivationRequest = async (id, token, formData, internalUser) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	// Build the params object with form data
	const params = {
		vessel_starlink_id: id,
		kit_nick_name: formData.nickname,
		group_name: formData.group_name,
		sub_group: formData.sub_group,
		public_ip: formData.public_ip ? 1 : 0,
		// block_product: 1,
		block_product: formData.block_product === 1 ? 1 : 0,

		is_scap: formData.isscap === "yes" ? true : false,

		...(formData.isscap === "yes" && {
			scap_config_id: formData.scapplan,
		}),

		...(formData.commitment && {
			commitment: formData.commitment,
		}),

		plan_details: {
			plan_type: formData.type.toUpperCase() === "LAND" ? "FIXE" : "MOBILE",

			...((formData.isscap === "no" || !formData.isscap) && {
				subscription_id: formData.subscription,
			}),

			...(formData.currentMonthOption &&
				formData.currentMonthOption.trim() !== "" && {
					current_month: {
						optin_type: formData.currentMonthOption,
						...(formData.currentMonthOption === "WITH_CREDIT_LIMIT" && {
							optin_value: formData.currentMonthValue,
						}),
					},
				}),
			...(formData.permanentOption &&
				formData.permanentOption.trim() !== "" && {
					permanent: {
						optin_type: formData.permanentOption,
						...(formData.permanentOption === "WITH_CREDIT_LIMIT" && {
							optin_value: formData.permanentValue,
						}),
					},
				}),
		},

		...(formData.fixed_address &&
			formData.type.toUpperCase() === "LAND" &&
			Object.keys(formData.fixed_address).length > 0 && {
				address: {
					address_lines: formData.fixed_address.address_lines,
					administrative_area_code: formData.fixed_address.administrative_area_code,
					formatted_address: formData.fixed_address.formatted_address,
					latitude: formData.fixed_address.latitude,
					longitude: formData.fixed_address.longitude,
					region_code: formData.fixed_address.region_code,
					country: formData.fixed_address.country,
				},
			}),

		...(formData.show_schedule_form === true &&
			formData.schedule_date != "" && {
				scheduled_at: formData.schedule_date,
			}),

		...(internalUser === true && {
			source: formData?.source || "",
			...(formData?.source === "Optisim" && {
				order: formData?.order || "",
			}),
		}),
	};

	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlink-activations`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};

export const postChangePlanRequest = async (id, token, formData, internalUser) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	if (formData.show_address_form) {
		if (!formData.fixed_address || Object.keys(formData.fixed_address).length === 0) {
			validationErrors.fixed_address = "Fixed Address is required.";
		}
	}
	// Build the params object with form data
	const params = {
		vessel_starlink_id: id,
		kit_nick_name: formData.nickname,
		public_ip: formData.public_ip ? 1 : 0,
		// block_product: 1,
		block_product: formData.block_product === 1 ? 1 : 0,

		plan_details: {
			plan_type: formData.type.toUpperCase() === "LAND" ? "FIXE" : "MOBILE",

			subscription_id: formData.subscription,
			...(formData.currentMonthOption &&
				formData.currentMonthOption.trim() !== "" && {
					current_month: {
						optin_type: formData.currentMonthOption,
						...(formData.currentMonthOption === "WITH_CREDIT_LIMIT" && {
							optin_value: formData.currentMonthValue,
						}),
					},
				}),
			...(formData.permanentOption &&
				formData.permanentOption.trim() !== "" && {
					permanent: {
						optin_type: formData.permanentOption,
						...(formData.permanentOption === "WITH_CREDIT_LIMIT" && {
							optin_value: formData.permanentValue,
						}),
					},
				}),
		},
		...(formData.commitment && {
			commitment: formData.commitment,
		}),
		...(formData.fixed_address &&
			formData.type.toUpperCase() === "LAND" &&
			Object.keys(formData.fixed_address).length > 0 && {
				address: {
					address_lines: formData.fixed_address.address_lines,
					administrative_area_code: formData.fixed_address.administrative_area_code,
					formatted_address: formData.fixed_address.formatted_address,
					latitude: formData.fixed_address.latitude,
					longitude: formData.fixed_address.longitude,
					region_code: formData.fixed_address.region_code,
					country: formData.fixed_address.country,
				},
			}),

		...(formData.schedule_date != "" && {
			scheduled_at: formData.schedule_date,
		}),

		...(internalUser === true && {
			source: formData?.source || "",
			...(formData?.source === "Optisim" && {
				order: formData?.order || "",
			}),
		}),
	};
	try {
		const response = await axios.post(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/plan-request`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};
export const postDeactivationRequest = async (id, token, type, params) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	let url;

	if (type === "force") {
		url = `${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/deactivation-starlink`;
	} else if (type === "remove" || type === "immediate") {
		url = `${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/deactivation`;
	}

	try {
		const response = await axios.put(url, params, config);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response) {
			const status = error.response.status;

			if (status === 401) {
				handleUnauthorized(dispatch, navigate);
			} else if (status === 422) {
				return { status, errors: error.response.data.errors };
			} else if (status === 400) {
				return {
					status,
					message: error.response.data.message || "Bad request",
					errors: error.response.data.errors || {},
				};
			}
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};
export const postDeactivationRequestRemove = async (id, token, params) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	try {
		const response = await axios.put(
			`${import.meta.env.VITE_API_BACKEND}api/vessel-starlinks/${id}/desactivation-remove`,
			params,
			config,
		);
		return { status: response.status, data: response.data };
	} catch (error) {
		if (error.response && error.response.status === 401) {
			handleUnauthorized(dispatch, navigate);
		} else {
			console.error("Error fetching device info:", error);
			throw error;
		}
	}
};
